import ct from "class-types.macro";
import React from "react";
import SupportFAQ from "../Models/SupportFAQ";
import QuestionsWrapper from "../Questions/QuestionsWrapper";

interface Props {
  searchValue: string;
  searchResults: readonly SupportFAQ[];
}

function SearchResult({ searchValue, searchResults }: Props) {
  return (
    <div className="support-faq-listing">
      <div className="support-results clears">
        <span className="header-2">
          Results for{" "}
          <span className={ct("text-green-500")}>{searchValue}</span>
        </span>
        <QuestionsWrapper
          questionList={searchResults}
          showCategoryNames={false}
        />
      </div>
    </div>
  );
}

export default SearchResult;
